import React from 'react';

import { useEffect, useState } from 'react';

import { useNavigate } from 'react-router-dom';

import { Breadcrumb } from '../../../components/Breadcrumb';
import { Button } from '../../../components/Button';
import { Footer } from '../../../components/Footer';
import { Header } from '../../../components/Header';
import { Tag } from '../../../components/Tag';
import './style.css';

import { CtaBlock } from '../../../components/CtaBlock';

import DateUtils from '../../../utils/DateUtils';

export const Unterrichtskonzepte = ({
    portalResource: portalResource,
    footerPortalResources: footerPortalResources,
    filterSettings: filterSettings,
    serverSettings: serverSettings,
    onToggleFilterParamSetting: onToggleFilterParamSetting,
    onToggleAreaCollapsedState: onToggleAreaCollapsedState,
}) => {
    const navigate = useNavigate();

    useEffect(() => {
        // The [] is for specifying dependencies, and for componentDidMount lifecycle equivalent
        // we need to specify no dependencies.
        // See https://stackoverflow.com/questions/53945763/componentdidmount-equivalent-on-a-react-function-hooks-component
    }, []);

    if (null == portalResource || null == footerPortalResources) {
        return null;
    }

    return (
        <div className="unterrichtskonzept">
            <Header
                className="design-component-instance-node-5"
                style="desktop"
                shareFeedbackEmailAddress={
                    serverSettings.shareFeedbackEmailAddress
                }
                logoDimensions={{
                    height: 64 * 1.8 + 'px',
                    width: 104 * 1.8 + 'px',
                }}
            />

            {buildIntroductoryInfoPart(portalResource)}

            {buildSearchFooter(filterSettings)}

            <Footer
                className="design-component-instance-node-5"
                logosPartnersGroupLogoPartnerBundesministerium="/img/BMBFSFJ_gefoerdert_vom_deutsch_Web_c.svg"
                property1="desktop"
            />
        </div>
    );

    // The codebase we received after export uses some kind of CSS reseting tool called meyer-reset
    // https://cdnjs.cloudflare.com/ajax/libs/meyer-reset/2.0/reset.min.css.
    // My understanding is limited, but the point of this tool is I think to strip all style from elements,
    // so that web designers can start fresh. A problem though is that I can't find a way to override its settings
    // for lists. I tried setting lists-style:revert on divs or <p> tags surrounding the list, but there is no effect.
    // The meyer-reset setting is always applied. The only thing that works is when the styling is specified directly
    // on the element. So what this function does is take the rawHtml a content authors via TinyMCE Editor, and search
    // for lists (with tag <ol> or <ul>) and rewrite them to include the styling necessary to remove the effect of
    // the meyer-reset... There has to be a better way ...
    function removeMeyerResetCSSListSettingsFromHtmlString(text) {
        if (null == text) {
            return null;
        } else {
            return text
                .replace('<ol>', '<ol style="list-style: revert;">')
                .replace('<ul>', '<ul style="list-style: revert;">');
        }
    }

    function buildIntroductoryInfoPart(portalResource) {
        let textSectionHTML = portalResource.sections[0].text;
        let linkSectionHTML = portalResource.sections[1].text;

        return (
            <div className="content-wrapper-2">
                <div className="content-11">
                    <div className="frame-24">
                        <div className="frame-25">
                            <div className="frame-26">
                                <Breadcrumb
                                    breadcrumb="two-level"
                                    className="design-component-instance-node-6"
                                    breadcrumbText={buildBreadCrumbTitle(
                                        portalResource.shortTitle,
                                        portalResource.title,
                                    )}
                                />
                                <div className="h">{portalResource.title}</div>
                                <div className="h-2">
                                    {
                                        null != portalResource.subTitle
                                            ? portalResource.subTitle
                                            : null /*Gamification beim Lernen*/
                                    }
                                </div>
                            </div>

                            <div className="div-17">
                                <Tag
                                    className="design-component-instance-node-6"
                                    size="default"
                                    stateProp="default"
                                    style="default"
                                    text={portalResource.mediaUsageGoal.goal}
                                    isClickable={false}
                                />

                                {null == portalResource.subjectMatterCategories
                                    ? null
                                    : portalResource.subjectMatterCategories.map(
                                          (cat, i) => {
                                              return (
                                                  <Tag
                                                      className="design-component-instance-node-6"
                                                      size="default"
                                                      stateProp="default"
                                                      style="default"
                                                      text={cat.category}
                                                      isClickable={false}
                                                  />
                                              );
                                          },
                                      )}

                                {null == portalResource.schoolTypes
                                    ? null
                                    : portalResource.schoolTypes.map(
                                          (schoolType, i) => {
                                              return (
                                                  <Tag
                                                      className="design-component-instance-node-6"
                                                      size="default"
                                                      stateProp="default"
                                                      style="default"
                                                      text={schoolType.name}
                                                      isClickable={false}
                                                  />
                                              );
                                          },
                                      )}
                            </div>

                            <div>
                                <p
                                    className="summary"
                                    dangerouslySetInnerHTML={{
                                        __html: removeMeyerResetCSSListSettingsFromHtmlString(
                                            textSectionHTML,
                                        ),
                                    }}
                                />
                            </div>

                            <div className="frame-27"></div>
                        </div>

                        <div className="image-and-link-box">
                            <div className="featured-image">
                                <div
                                    className="frame-29"
                                    style={{
                                        backgroundImage:
                                            'url(' +
                                            portalResource.titleImage +
                                            ')',
                                    }}
                                />
                            </div>

                            <div style={{ marginTop: '3em' }}></div>

                            <CtaBlock
                                useHomepageCtaBlockStyleButton={false}
                                buttonTextLink={null}
                                className="design-component-instance-node-7"
                                stateProp="default"
                                style="default"
                                text={
                                    <div>
                                        <div>
                                            Das ausführliche Unterrichtskonzept
                                            finden Sie hier:
                                        </div>
                                        <div className="link-section"
											style={{maxWidth: (/* A crude way of making sure long links get wrapped, to avoid having the picture + linkbox 
																  combo appear on a line under the  left text. Should check with a CSS expert for how to do this
																  better.
																*/
													("Das ausführliche Unterrichtskonzept finden Sie hier:".length / 2) + "em")}}>
                                            <p
                                                dangerouslySetInnerHTML={{
                                                    __html: removeMeyerResetCSSListSettingsFromHtmlString(
                                                        linkSectionHTML,
                                                    ),
                                                }}
                                            />
                                        </div>
                                    </div>
                                }
                                title={null}
                                outerBoxShouldUseFullWidth={true}
                                showLink={true}
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    function buildSearchFooter(filterSettings) {
        return (
            <div className="hero-section">
                <div className="content-18">
                    <div className="frame-33">
                        <p
                            className="subtitle-6"
                            style={{ marginBottom: '0px' }}
                        >
                            Ich interessiere mich für...
                        </p>

                        <p
                            className="subtitle-6"
                            style={{
                                fontSize: '1.5em',
                                fontWeight: 'normal',
                                marginTop: '-35px',
                            }}
                        >
                            Klicken Sie, um passende Ressourcen zu finden
                        </p>

                        <div className="categories-menu">
                            <div className="column">
                                {filterSettings.slice(0, 1).map((area, i) => {
                                    return (
                                        <div
                                            key={'homepage-tags-div' + '-' + i}
                                            className="category-list-2"
                                        >
                                            <div className="list-item-3">
                                                <div className="title-7">
                                                    <div className="title-8">
                                                        {area.userFriendlyLabel}
                                                    </div>
                                                </div>

                                                <div className="nav-vertical-2">
                                                    {area.subAreas.map(
                                                        (subArea, j) => {
                                                            return (
                                                                <Tag
                                                                    key={
                                                                        'homepage-tag-' +
                                                                        subArea.label +
                                                                        '-' +
                                                                        j
                                                                    }
                                                                    className="design-component-instance-node-8"
                                                                    size="default"
                                                                    stateProp={
                                                                        subArea.isActive
                                                                            ? 'active'
                                                                            : 'default'
                                                                    }
                                                                    style="default"
                                                                    text={
                                                                        subArea.label
                                                                    }
                                                                    onClick={() => {
                                                                        onToggleFilterParamSetting(
                                                                            area.label,
                                                                            subArea.label,
                                                                        );

                                                                        if (
                                                                            area.isCollapsed
                                                                        ) {
                                                                            onToggleAreaCollapsedState(
                                                                                area.label,
                                                                            );
                                                                        }
                                                                    }}
                                                                />
                                                            );
                                                        },
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>

                            <div className="column">
                                {filterSettings.slice(1, 2).map((area, i) => {
                                    return (
                                        <div
                                            key={'homepage-tags-div' + '-' + i}
                                            className="category-list-2"
                                        >
                                            <div className="list-item-3">
                                                <div className="title-7">
                                                    <div className="title-8">
                                                        {area.userFriendlyLabel}
                                                    </div>
                                                </div>

                                                <div className="nav-vertical-2">
                                                    {area.subAreas.map(
                                                        (subArea, j) => {
                                                            return (
                                                                <Tag
                                                                    key={
                                                                        'homepage-tag-' +
                                                                        subArea.label +
                                                                        '-' +
                                                                        j
                                                                    }
                                                                    className="design-component-instance-node-8"
                                                                    size="default"
                                                                    stateProp={
                                                                        subArea.isActive
                                                                            ? 'active'
                                                                            : 'default'
                                                                    }
                                                                    style="default"
                                                                    text={
                                                                        subArea.label
                                                                    }
                                                                    onClick={() => {
                                                                        onToggleFilterParamSetting(
                                                                            area.label,
                                                                            subArea.label,
                                                                        );

                                                                        if (
                                                                            area.isCollapsed
                                                                        ) {
                                                                            onToggleAreaCollapsedState(
                                                                                area.label,
                                                                            );
                                                                        }
                                                                    }}
                                                                />
                                                            );
                                                        },
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>

                            <div className="column">
                                {filterSettings.slice(3).map((area, i) => {
                                    return (
                                        <div
                                            key={'homepage-tags-div' + '-' + i}
                                            className="category-list-2"
                                        >
                                            <div className="list-item-3">
                                                <div className="title-7">
                                                    <div className="title-8">
                                                        {area.userFriendlyLabel}
                                                    </div>
                                                </div>

                                                <div className="nav-vertical-2">
                                                    {area.subAreas.map(
                                                        (subArea, j) => {
                                                            return (
                                                                <Tag
                                                                    key={
                                                                        'homepage-tag-' +
                                                                        subArea.label +
                                                                        '-' +
                                                                        j
                                                                    }
                                                                    className="design-component-instance-node-8"
                                                                    size="default"
                                                                    stateProp={
                                                                        subArea.isActive
                                                                            ? 'active'
                                                                            : 'default'
                                                                    }
                                                                    style="default"
                                                                    text={
                                                                        subArea.label
                                                                    }
                                                                    onClick={() => {
                                                                        onToggleFilterParamSetting(
                                                                            area.label,
                                                                            subArea.label,
                                                                        );

                                                                        if (
                                                                            area.isCollapsed
                                                                        ) {
                                                                            onToggleAreaCollapsedState(
                                                                                area.label,
                                                                            );
                                                                        }
                                                                    }}
                                                                />
                                                            );
                                                        },
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    </div>
                    <Button
                        className="design-component-instance-node-8"
                        status="default"
                        style="default"
                        textLink="Los geht's!"
                        onClick={() => {
                            navigate('/directory');
                        }}
                    />
                </div>
            </div>
        );
    }

    function buildBreadCrumbTitle(shortTitle, fullTitle) {
        if (null != shortTitle) {
            return shortTitle;
        } else {
            return fullTitle;
        }
    }
};
